import React from 'react'
import StatusIcon from '../../Icons/StatusIcon'
import loadable from '@loadable/component';
const InvoiceListComponent = loadable(
  () => import("../../components/Finance/InvoiceList")
);

const Invoice = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Invoices</span>
      </div>
      <InvoiceListComponent />
    </>
  )
}

export default Invoice
